import React, { useEffect, useState } from 'react';
import styles from './Banner.module.css';

const Banner = ({ onClose, onOpenModal, message, type }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const isDefault = !message;
  const bannerClass =
    type === 'success'
      ? styles.Banner__Success
      : type === 'error'
        ? styles.Banner__Error
        : styles.Banner__Default;

  return (
    <div
      className={`${styles.Banner__Wrapper} ${visible ? styles.Banner__Show : ''} ${bannerClass}`}
    >
      <p className={styles.Banner__Text} onClick={onOpenModal}>
        {message || 'Need help identifying a Fyntiq charge on your statement?'}
      </p>
      <div className={styles.Banner__Actions}>
        {isDefault && (
          <button className={styles.OpenModal__Btn} onClick={onOpenModal}>
            Yes, I need help
          </button>
        )}
        <button
          className={styles.Close__Btn}
          onClick={() => {
            setVisible(false);
            setTimeout(onClose, 300);
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default Banner;
